// interfaces
import { STATUS_TYPES } from "../constants";
import { AttachedfileTypes, MediaTypes } from "../types/profile";

// ============================
export interface IContact {
  id: number;
  idEnterprise: number;
  idCliente: number;
  cpf: string;
  name: string;
  email: string;
  avatar: string;
  lastMessageText: string;
  unreadCount: number;
  lastMessageTime?: string;
  blockedMessage?: string;
  isGroup: boolean;
  robot: boolean;
  members: number | null;
  phoneNumber: string;

  cpfCnpj?: string;
  fullName?: string;
  address?: string;
  situacao?: string;

  obs?: string;
  obsAtendimento?: string;

  foto1?: string;
  foto2?: string;
  foto3?: string;

  arquivo1?: string;
  arquivo2?: string;

  ativo?: number;
  marked?: number;
  idRegiao?: number;
  regiao?: string;

  dataVisita?: string;
  obsVisita?: string;
}

// ============================
// UI TYPE (lista lateral)
// ============================
export interface IUserTypes {
  id: number;
  idEnterprise: number;
  idCliente: number;
  cpf: string;
  name: string;
  email: string;
  avatar: string;
  lastMessageText?: string;
  unreadCount: number;
  lastMessageTime?: string;
  blockedMessage?: string;
  isGroup: boolean;
  members: number | null;
  phoneNumber?: string;

  cpfCnpj?: string;
  fullName?: string;
  address?: string;
  situacao?: string;

  obs?: string;
  obsAtendimento?: string;

  foto1?: string;
  foto2?: string;
  foto3?: string;

  arquivo1?: string;
  arquivo2?: string;

  ativo?: number;
  marked?: number;
  idRegiao?: number;
  regiao?: string;

  dataVisita?: string;
  obsVisita?: string;

  robot: boolean;
}

// ============================
// Mapeia item único
// ============================
export const mapContactToUserTypes = (c: IContact): IUserTypes => ({
  id: c.id,
  idCliente: c.idCliente,
  idEnterprise: c.idEnterprise,
  cpf: c.cpf,
  name: c.name,
  email: c.email,
  avatar: c.avatar,
  lastMessageText: c.lastMessageText,
  unreadCount: c.unreadCount,
  lastMessageTime: c.lastMessageTime,
  blockedMessage: c.blockedMessage,
  isGroup: c.isGroup,
  members: c.members,
  phoneNumber: c.phoneNumber ?? "",

  foto1: c.foto1 ?? "",
  foto2: c.foto2 ?? "",
  foto3: c.foto3 ?? "",

  arquivo1: c.arquivo1 ?? "",
  arquivo2: c.arquivo2 ?? "",

  address: c.address ?? "",
  cpfCnpj: c.cpfCnpj ?? "",
  situacao: c.situacao ?? "",
  fullName: c.fullName ?? "",
  obs: c.obs ?? "",
  obsAtendimento: c.obsAtendimento ?? "",

  robot: c.robot ?? false,
  ativo: c.ativo ?? -2,
  marked: c.marked ?? 0,
  idRegiao: c.idRegiao ?? 0,
  regiao: c.regiao ?? "Indefinido",

  dataVisita: c.dataVisita ?? "",
  obsVisita: c.obsVisita ?? "",
});

// ============================
// Mapeia lista completa
// ============================
export const mapContactsToUserTypes = (list: IContact[]): IUserTypes[] =>
  Array.isArray(list) ? list.map(mapContactToUserTypes) : [];

export function parseContactShared(body: string) {
  if (!body) {
    return {
      title: "",
      name: "",
      phone: "",
    };
  }

  let clean = body.replace("Contato compartilhado:", "").trim();

  const parts = clean.split(" - ");
  const name = parts[0]?.trim() ?? "";
  const phone = parts[1]?.trim() ?? "";

  return {
    title: "Contato compartilhado",
    name,
    phone,
  };
}

export interface ChannelTypes {
  id: number | string;
  name: string;
  meta?: {
    unRead: number;
  };
}

export interface ContactTypes {
  id: string | number;
  firstName: string;
  lastName: string;
  profileImage?: any;
  about?: string;
  email: string;
  location: string;
  channels?: Array<ChannelTypes>;
  media?: MediaTypes;
  attachedFiles?: AttachedfileTypes;
  status?: STATUS_TYPES;
  isFavourite?: boolean;
  isArchived?: boolean;
}

export interface ITag {
  id: number;
  name: string;
}

export const tagListHuman: ITag[] = [
  {
    id: 0,
    name: "Tudo",
  },
  {
    id: 1,
    name: "Nova",
  },
  {
    id: 2,
    name: "Ativa",
  },

  {
    id: 4,
    name: "Marcada",
  },
  {
    id: 5,
    name: "Favoritos",
  },
  {
    id: 6,
    name: "Bloqueado",
  },
  {
    id: 7,
    name: "Duvidas",
  },

  // {
  //   id: 3,
  //   name: "Finalizada",
  // },
];

export const tagListBot: ITag[] = [
  {
    id: 0,
    name: "Tudo",
  },
  {
    id: 1,
    name: "Ativas",
  },
  {
    id: 2,
    name: "Agendadas",
  },

  // {
  //   id: 3,
  //   name: "Inatividade 12hs",
  // },
];

export interface IRegion {
  id: number;
  idRegiao: number;
  nome: string;
  uf: string;
}

export const regionList: IRegion[] = [
  {
    id: -1,
    idRegiao: -1,
    nome: "TODAS",
    uf: "TO",
  },
  {
    id: 0,
    idRegiao: 0,
    nome: "SEM REGIÃO",
    uf: "SR",
  },
  {
    id: 1,
    idRegiao: 1,
    nome: "SAO PAULO",
    uf: "SP",
  },
  {
    id: 2,
    idRegiao: 2,
    nome: "LONDRINA",
    uf: "LO",
  },
  {
    id: 3,
    idRegiao: 3,
    nome: "CURITIBA",
    uf: "CB",
  },
  {
    id: 4,
    idRegiao: 4,
    nome: "PONTA GROSSA",
    uf: "LO",
  },
  {
    id: 5,
    idRegiao: 5,
    nome: "MARINGA",
    uf: "MA",
  },
  {
    id: 6,
    idRegiao: 6,
    nome: "SOROCABA",
    uf: "MA",
  },
];
